// Virus-scan status badge (MOD-02+ / Blok A pipeline). Clean/Skipped are safe;
// Pending is in-flight; Infected/Failed are quarantined/unservable.

import type { ReactNode } from 'react';
import { Tag, Tooltip } from 'antd';
import { ShieldAlert, ShieldCheck, ShieldQuestion } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import type { FileScanStatus } from '@api/files';

interface Meta {
  color: string;
  icon: ReactNode;
  label: 'scan.clean' | 'scan.skipped' | 'scan.pending' | 'scan.infected' | 'scan.failed';
  hint: 'scan.cleanHint' | 'scan.skippedHint' | 'scan.pendingHint' | 'scan.infectedHint' | 'scan.failedHint';
}

const META: Record<FileScanStatus, Meta | null> = {
  None: null,
  Clean: { color: 'success', icon: <ShieldCheck size={12} />, label: 'scan.clean', hint: 'scan.cleanHint' },
  Skipped: { color: 'default', icon: <ShieldCheck size={12} />, label: 'scan.skipped', hint: 'scan.skippedHint' },
  Pending: { color: 'processing', icon: <ShieldQuestion size={12} />, label: 'scan.pending', hint: 'scan.pendingHint' },
  Infected: { color: 'error', icon: <ShieldAlert size={12} />, label: 'scan.infected', hint: 'scan.infectedHint' },
  Failed: { color: 'error', icon: <ShieldAlert size={12} />, label: 'scan.failed', hint: 'scan.failedHint' },
};

export function ScanStatusTag({ status }: { status: FileScanStatus }) {
  const { t } = useTranslation('media');
  const meta = META[status];
  if (!meta) return null;
  return (
    <Tooltip title={t(meta.hint)}>
      <Tag color={meta.color} icon={meta.icon} style={{ margin: 0 }}>
        {t(meta.label)}
      </Tag>
    </Tooltip>
  );
}
